import { Alert, AlertTitle, AlertDescription, Button } from '@chakra-ui/react';
import { FC, useState } from 'react';
import { IAccommodationStatus } from '../../../../../types';
import { AccommodationStatusDescription, statusColorScheme } from './helpers';
import { AccommodationStatusModal } from './modal';

export interface IProps {
  saveAccommodationStatus: (data: IAccommodationStatus) => void;
  accommodationStatus: IAccommodationStatus;
  universityAccommodationEnabled: boolean;
}

export const AccommodationStatus: FC<IProps> = ({
  accommodationStatus,
  saveAccommodationStatus,
  universityAccommodationEnabled
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Alert
      as="div"
      role="generic"
      data-selector="enrolment-section-accommodation-status-block"
      variant="status-block"
      colorScheme={statusColorScheme({ accommodationStatus })}
    >
      <AlertTitle as="h3">Accommodation Status</AlertTitle>

      <AlertDescription>
        <AccommodationStatusDescription accommodationStatus={accommodationStatus} />
      </AlertDescription>

      <Button
        variant="solid"
        size="lg"
        data-selector="enrolment-section-accommodation-status-button"
        onClick={() => setIsModalOpen(true)}
        mt={4}
      >
        Update accommodation status
      </Button>

      {isModalOpen && (
        <AccommodationStatusModal
          saveAccommodationStatus={saveAccommodationStatus}
          accommodationStatus={accommodationStatus}
          onModalClose={() => setIsModalOpen(false)}
          universityAccommodationEnabled={universityAccommodationEnabled}
        />
      )}
    </Alert>
  );
};
